var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircleOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.383 0 0 5.383 0 12c0 6.618 5.383 12 12 12s12-5.382 12-12c0-6.617-5.383-12-12-12m0 21.6c-5.293 0-9.6-4.307-9.6-9.6S6.707 2.4 12 2.4s9.6 4.307 9.6 9.6-4.307 9.6-9.6 9.6m-1.046-3.829L6.14 12.958l2.104-2.104 2.33 2.328 4.93-6.903 2.423 1.73z",
  clipRule: "evenodd"
})));
export default SvgCheckCircleOutlined;